import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .then(() => {
    if ('serviceWorker' in navigator && environment.production) {
      console.log('intentando registrar en main');
      // navigator.serviceWorker.getRegistrations().then(function(registrations) {
      //   for (const registration of registrations) {
      //     if (
      //       registration.active &&
      //       registration.active.scriptURL // &&
      //       // registration.active.scriptURL.indexOf('ngsw-worker.js') > -1
      //     ) {
      //       console.log(
      //         'voy a desregistrar a ' + registration.active.scriptURL
      //       );
      //       registration.unregister();
      //     }
      //   }
      // });
      navigator.serviceWorker.register('sw-master.js');
    }
  })
  .catch(err => console.log(err));
